import getFingerprint from './fingerprint';
import getFraudSessionId, { KountParams } from './kount';
import { getIsAdBlockEnabled } from './adblock-detect';

export interface RiskMetadata {
  fingerprint: string | null;
  extraData: {
    kountFraudSessionId: string | null;
  };
  browserData: {
    colorDepth: number | null;
    isJavaEnabled: boolean | null;
    language: string | null;
    screenHeight: number | null;
    screenWidth: number | null;
    timeZoneOffset: number;
    isAdBlockEnabled: boolean | null;
  };
}

async function collectDataHelper({
  env = null,
  kountAccountId = null,
  kountSessionId = null,
}: KountParams): Promise<{ riskMetadata: RiskMetadata }> {
  const { colorDepth, height: screenHeight, width: screenWidth } = screen || {};
  const { javaEnabled, language } = navigator || {};

  let fingerprint: string | null = null;
  let kountFraudSessionId: string | undefined;
  let isAdBlockEnabled: boolean | null = null;

  try {
    [isAdBlockEnabled, fingerprint, kountFraudSessionId] = await Promise.all([
      getIsAdBlockEnabled(),
      getFingerprint(),
      kountAccountId
        ? getFraudSessionId({
            env,
            kountAccountId,
            kountSessionId,
          })
        : undefined,
    ]);
  } catch (e) {
    console.error(e);
  }

  const data = {
    riskMetadata: {
      fingerprint: fingerprint || null,
      extraData: {
        kountFraudSessionId: kountFraudSessionId || null,
      },
      browserData: {
        colorDepth: colorDepth || null,
        isJavaEnabled: javaEnabled ? javaEnabled.call(navigator) : null,
        language: language || null,
        screenHeight: screenHeight || null,
        screenWidth: screenWidth || null,
        timeZoneOffset: new Date().getTimezoneOffset(),
        isAdBlockEnabled,
      },
    },
  };

  return data;
}

async function collectData(
  { env = null, kountAccountId = null, kountSessionId = null }: KountParams = {
    env: null,
    kountAccountId: null,
  },
) {
  return collectDataHelper({
    env,
    kountAccountId,
    kountSessionId,
  });
}

export { collectData };
